import { MailEntry } from "./MailEntry";

export class ReminderData
{
  mailEntries:MailEntry[];

  static create()
  {
    let rd = new ReminderData();
    rd.mailEntries = [];
    return rd;
  }
}